import { useEffect, useState } from 'react';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';

/**
 * Returns the Authenticated users name.
 * returns empty string until authentication occurs.
 * example: const username = useAgUsername();
 *
 */
export const useAgUsername = () => {
  const [username, setUsername] = useState('');
  const isAuthenticated = useIsAuthenticated();
  const msalContext = useMsal();

  useEffect(() => {
    const { instance } = msalContext;
    const activeAccount =
      instance.getActiveAccount() || (msalContext.accounts.length && msalContext.accounts[0]);
    if (isAuthenticated && activeAccount) {
      const [name] = activeAccount.username?.split('@') || '';
      if (name) setUsername(name);
    }
  }, [isAuthenticated, msalContext]);
  return username;
};

/**
 * Returns the Authenticated users username and role.
 * example: const access = useAgAccess();
 *
 */
// export const useAgAccess = () => {
//     const username: string = useAgUsername();
//     const userData: Employee | undefined = employeeData?.find(employee => employee.workEmail?.split('@')[0] || '' === username);
//     return {username, jobCategory: userData?.jobCategory, jobLevel: userData?.jobLevel};
// }
